import SocketCommand from '@/api/SocketCommand.js'
import KdsOrderPriorityEnum from '@/api/Enums/KdsOrderPriorityEnum.js'
import KdsOrderStatusEnum from '@/api/Enums/KdsOrderStatusEnum.js'
import KdsOrderItemStatusEnum from '@/api/Enums/KdsOrderItemStatusEnum.js'

export default {
  dataStore: {
    kdsOrders: 'kds.Orders'
  },

  data() {
    return {}
  },

  methods: {
    //\\ Order Actions //\\
    onKdsOrderCompleteClick(order) {
      if (!order) return

      this.$set(order, 'kdsOrderCompleteLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangeStatus, {Id: order.Id, OrderId: order.Id, OrderUid: order.Uid, Status: KdsOrderStatusEnum.COMPLETE})
      this.isVisible = false
    },

    onKdsOrderRevertClick(order) {
      if (!order) return

      this.$set(order, 'kdsOrderRevertLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangeStatus, {Id: order.Id, OrderId: order.Id, OrderUid: order.Uid, Status: KdsOrderStatusEnum.OPEN})
      this.isVisible = false
    },

    onKdsOrderHoldClick(order) {
      if (!order) return

      this.$set(order, 'kdsOrderHoldLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangeStatus, {Id: order.Id, OrderId: order.Id, OrderUid: order.Uid, Status: KdsOrderStatusEnum.HOLD})
      this.isVisible = false
    },

    onKdsOrderResumeClick(order) {
      if (!order) return

      this.$set(order, 'kdsOrderResumeLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangeStatus, {Id: order.Id, OrderId: order.Id, OrderUid: order.Uid, Status: KdsOrderStatusEnum.OPEN})
      this.isVisible = false
    },

    onKdsOrderMoveForwardClick(order) {
      if (!order) return

      this.$set(order, 'kdsOrderMoveForwardLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangePriority, {Id: order.Id, OrderId: order.Id, OrderUid: order.Uid, Action: KdsOrderPriorityEnum.PREVIOUS})
      this.isVisible = false
    },

    onKdsOrderMoveBackwardClick(order) {
      if (!order) return

      this.$set(order, 'kdsOrderMoveBackwardLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangePriority, {Id: order.Id, OrderId: order.Id, OrderUid: order.Uid, Action: KdsOrderPriorityEnum.NEXT})
      this.isVisible = false
    },

    onKdsOrderMoveFirstClick(order) {
      if (!order) return

      this.$set(order, 'kdsOrderMoveFirstLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangePriority, {Id: order.Id, OrderId: order.Id, OrderUid: order.Uid, Action: KdsOrderPriorityEnum.FIRST})
      this.isVisible = false
    },

    onKdsOrderMoveLastClick(order) {
      if (!order) return

      this.$set(order, 'kdsOrderMoveLastLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangePriority, {Id: order.Id, OrderId: order.Id, OrderUid: order.Uid, Action: KdsOrderPriorityEnum.LAST})
      this.isVisible = false
    },

    //\\ Item Actions //\\
    onKdsOrderItemStartClick(item, order) {
      if (!item || !order) return

      this.$set(item, 'kdsOrderItemStartLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangeItemStatus, {Id: item.OrderMenuId, OrderId: order.Id, OrderUid: order.Uid, Status: KdsOrderItemStatusEnum.START})
    },

    onKdsOrderItemHoldClick(item, order) {
      if (!item || !order) return

      this.$set(item, 'kdsOrderItemHoldLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangeItemStatus, {Id: item.OrderMenuId, OrderId: order.Id, OrderUid: order.Uid, Status: KdsOrderItemStatusEnum.HOLD})
    },

    onKdsOrderItemCompleteClick(item, order) {
      if (!item || !order) return

      this.$set(item, 'kdsOrderItemCompleteLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangeItemStatus, {Id: item.OrderMenuId, OrderId: order.Id, OrderUid: order.Uid, Status: KdsOrderItemStatusEnum.COMPLETE})
    },

    onKdsOrderItemRevertClick(item, order) {
      if (!item || !order) return

      this.$set(item, 'kdsOrderItemRevertLoading', true)
      window.callAS(SocketCommand.Kds.Order.ChangeItemStatus, {Id: item.OrderMenuId, OrderId: order.Id, OrderUid: order.Uid, Status: KdsOrderItemStatusEnum.START})
    }
  }
}
